import { render } from "./addresslist.vue?vue&type=template&id=dadccbb4"
import script from "./addresslist.vue?vue&type=script&lang=js"
export * from "./addresslist.vue?vue&type=script&lang=js"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__